import { Container, Row, Col, Image } from 'react-bootstrap';
import '../Profile/Profile.css';
import ProfileImg1 from '../../Assets/Img/BaeWonsikProfileWebP.webp';
import Banner from '../../Components/Layout/Banner/Banner.js';

function Profile() {
    return (
        <>
            <Banner />
            <Container className="profile-container py-5">
                <Row className="justify-content-center g-4">

                    {/* 배원식 변호사님 프로필 */}
                    <Col xs={12} md={10} lg={8} className="d-flex justify-content-center">
                        <Image
                            src={ProfileImg1}
                            className="profile-main-img shadow-sm"
                            fluid
                        />
                    </Col>

                    {/* [나중에 추가될 때 아래 주석을 풀고 사용]
                    <Col xs={12} md={10} lg={8} className="d-flex justify-content-center">
                        <Image 
                            src={ProfileImg2} 
                            className="profile-main-img shadow-sm" 
                            fluid 
                        />
                    </Col> 
                    */}

                </Row>
            </Container>
        </>
    );
}

export default Profile;